import { createContext, useRef, useState } from "react";

export const ConfigContext = createContext();

const ConfigContextProvider = ({ children }) => {
  const identityWindow = useRef(null);
  // How do I prevent Google Chrome from blocking my popup?
  const [showIframe, setShowIframe] = useState(false);
  const iframe = useRef();
  const [remaining, setRemaining] = useState(0);
  const [step, setStep] = useState(2);
  const [updateProfileState, setUpdateProfileState] = useState(false);
  const [followApiState, setFollowApiState] = useState(false);
  const [unsubscribeState, setUnsubscribeState] = useState(false);
  const [createSubscriptionState, setCreateSubscriptionState] = useState(false);
  const [selectTweetState, setSelectTweetState] = useState(false);
  const [identityState, setIdentityState] = useState(false);
  const value = {
    identityWindow,
    iframe,
    showIframe,
    setShowIframe,
    remaining,
    setRemaining,
    step,
    setStep,
    updateProfileState,
    setUpdateProfileState,
    followApiState,
    setFollowApiState,
    unsubscribeState,
    setUnsubscribeState,
    createSubscriptionState,
    setCreateSubscriptionState,
    selectTweetState,
    setSelectTweetState,
    identityState,
    setIdentityState,
  };
  return (
    <ConfigContext.Provider value={value}>{children}</ConfigContext.Provider>
  );
};

export default ConfigContextProvider;
